
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 206","transform":"translate(-19 -374)","fill":"#c22292"}},[_c('rect',{attrs:{"data-name":"Rectangle 60","width":"28","height":"28","rx":"14","transform":"translate(19 374)","opacity":".1"}}),_c('path',{attrs:{"data-name":"Tracé 5428","d":"M38.523 386.981v1.989h-4.4v4.794h-2.241v-4.794h-4.404v-1.989h4.4v-4.794h2.241v4.794z"}})])])
          )
        }
      }
    